import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { IdentitySection } from '../components/IdentitySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-491">
      <HeroSection data-id="element-492" />
      <StorySection data-id="element-493" />
      <PainSection data-id="element-494" />
      <MechanismSection data-id="element-495" />
      <ProductSection data-id="element-496" />
      <TestimonialsSection data-id="element-497" />
      <OfferSection data-id="element-498" />
      <GuaranteeSection data-id="element-499" />
      <UrgencySection data-id="element-500" />
      <ObjectionsSection data-id="element-501" />
      <IdentitySection data-id="element-502" />
      <FinalCTASection data-id="element-503" />
      <Footer data-id="element-504" />
    </div>;
}